import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {Fee} from "../../../model/mapping/fee";
import {MappingFeeService} from "../../../services/mapping/mapping-fee.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class FeeComponent extends CrudBaseComponent<Fee> {

  //fields
  currencies: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingFeeService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new Fee();
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.originCode = undefined;
      this.formRecord.code = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'code',
        width: 130
      },
      {
        field: 'value',
        width: 130
      },
      {
        field: 'currency',
        width: 130,
        icon: record => 'cc-ico',
        iconValue: record => {
          const currField = this.currencies ? this.currencies.find(value => value.id === record.currency) : undefined;
          if (currField)
            return currField.value;
          return ''
        }
      },
      {
        field: 'description',
        width: 250
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'code',
            required: true,
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'value',
            required: true,
            column: 4,
            type: TYPE.DECIMAL
          },
          {
            field: 'currency',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.currencies,
            icon: id => 'cc-ico',
            iconValue: id => {
              const currField = this.currencies && this.currencies.find(value => value.id === id) ?
                this.currencies.find(value => value.id === id) : undefined;
              if (currField)
                return currField.value;
              return ''
            }
          },
          {
            field: 'description',
            column: 6,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();
    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getCurrencies(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100;
      this.currencies = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
  }

  onFormShow() {
  }
}
